import { render, staticRenderFns } from "./UpdatePartner.vue?vue&type=template&id=086ff5ea&scoped=true&"
import script from "./UpdatePartner.vue?vue&type=script&lang=js&"
export * from "./UpdatePartner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "086ff5ea",
  null
  
)

export default component.exports